/**
 * linked-family.js
 * ============================================================================
 * Linked Family Product Swatch Component
 *
 * Provides desktop mouse wheel horizontal scrolling support so users can easily
 * scroll through swatches on desktop using their mouse wheel or trackpad.
 * ============================================================================
 */

(function () {
  'use strict';

  function initDesktopWheelScroll() {
    const tracks = document.querySelectorAll('[data-linked-family-track]');

    tracks.forEach((track) => {
      if (track.dataset.wheelScrollInit) return;
      track.dataset.wheelScrollInit = '1';

      // Convert vertical mouse wheel scrolling into smooth horizontal scroll
      track.addEventListener('wheel', (e) => {
        // Only convert vertical scroll when horizontal scroll space exists
        if (e.deltaY !== 0 && track.scrollWidth > track.clientWidth) {
          e.preventDefault();
          track.scrollLeft += e.deltaY;
        }
      }, { passive: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopWheelScroll);
  } else {
    initDesktopWheelScroll();
  }

  // Shopify Theme Customizer section load
  document.addEventListener('shopify:section:load', initDesktopWheelScroll);
})();
